import React from 'react';
import AuditLogSliderContentBlock from './AuditLogSliderContentBlock';

// Blocks are always arrays of arrays. Every change in a batch (putSyncBatch) is one array. And changes can have multiple properties changed, so you may end up with nested arrays.

const AuditLogSliderContent = ({ blocks }) => {
  return blocks.map((block, index) => {
    if (Array.isArray(block) && block.every((b) => ['lexical', 'select'].includes(b?.type))) {
      // Multiple values is enabled
      return <AuditLogSliderContent key={index} blocks={block} />;
    }
    if (Array.isArray(block)) {
      return (
        <div className="audit-log-item-content" key={index}>
          <AuditLogSliderContent blocks={block} />
        </div>
      );
    }
    if (!block || typeof block !== 'object') {
      return (
        <div className="audit-log-item-content-string" key={`${block}-${index}`}>
          {String(block)}
        </div>
      );
    }
    if (block?.type === 'text' || block?.type === 'select' || block?.type === 'custom') {
      const label = block.label ?? block.value ?? '';
      return (
        <div className="audit-log-item-content-string bold" key={`${block?.id || label || ''}-${index}`}>
          {typeof label === 'object' ? JSON.stringify(label) : String(label)}
          {block.type === 'select' && index < blocks.length - 1 && ','}
        </div>
      );
    }
    if (!block?.label && !block?.value && !block?.id) {
      // Cases like { isActive: true } which are an object but not one of our blocks
      return (
        <div className="audit-log-item-content-string bold" key={`${index}`}>
          {JSON.stringify(block)}
        </div>
      );
    }
    return <AuditLogSliderContentBlock key={index} block={block} />;
  });
};

export default AuditLogSliderContent;
